import { useGetUserNameWithFallback } from '@pba/react-utils';
import type { PayerBase, TransactionItemDetail } from 'models';
import { useTranslation } from 'react-i18next';
import { AvatarWrapper, Text, useFormatPrice } from 'ui';
import { useUser } from 'features/auth';

type P = {
  transactionItem: TransactionItemDetail;
  user: PayerBase;
};

const UserSimpleContent = ({ transactionItem, user }: P) => {
  const { t } = useTranslation();
  const formatPrice = useFormatPrice();
  const { railsUserData: viewer } = useUser();
  const getUserNameWithFallback = useGetUserNameWithFallback();
  const name = getUserNameWithFallback(user);

  return (
    <AvatarWrapper
      avatar={{ alt: t('userAvatarProfilePhoto', { name }), src: user.profilePhoto }}
      extra={<Text>{formatPrice({ value: transactionItem.amount })}</Text>}
      user={{ isViewer: user.id === viewer.id, name }}
    />
  );
};

export default UserSimpleContent;
